// @flow
export const SHOW_SEARCH: string = 'SHOW_SEARCH'
export const TOGGLE_SEARCH: string = 'TOGGLE_SEARCH'
export const CLOSE_SEARCH: string = 'CLOSE_SEARCH'
